import React, { useState, useEffect } from 'react';
import Chrono from './Chrono.js';



const HelpChat = ({ uid, username, roomId, channel, server_host, onVoiceMe, onLogout, is_owner, is_coach }) => {
  const [message, setMessage] = useState('');
  const [chronoDuration, setChronoDuration] = useState(0);

  const vingt_minutes = useState( 20 * 60 * 1000)

  const decreaseTime = (t) => {
    if (t === -1) {
      setChronoDuration(prevTime => {
         return prevTime - 1000
    })
    } else {
      setChronoDuration(t)
    }
  }

  const request_an_account_update_form = () => {
    const request = {uid, username};
    channel.emit('getUserAccountForm', request)
  };
  
  
    /*

  useEffect(() => {
    channel.emit('login', { username });

    channel.on('init room messages', (room, user, mess) => {
      if (({roomId} == room) && (user == uid)){
        setMessages(mess)
      }
    });
    

    channel.on('chat message', (data) => {
      if (data.room === 'help')
        setMessages((prevMessages) => [...prevMessages, data]);
    });

    //return (username) => {
    //    socket.emit('logout', uid)
    //    socket.off()
    //}

  });
  */

  
/*
  const handleSendHelpMessage = () => {
    if (message) {
      const contenu = message
      channel.emit('chat message', { contenu, uid, roomId });
      setMessage('');
    }
  };
*/

    let protocol = process.env.REACT_APP_PROTOCOL
    if (protocol === undefined){
      protocol = "http"
    }


  return (
    <div className='chat-header'>
    {/*}  <div width='50%' className="help-messages">
        {messages.map((msg, index) => (
          <div className = {msg.origin == username ? "selfPastMessage" : "pastMessage"} key={index}>
            {msg.origin}: {msg.message}
          </div>
        ))}
      </div>*/}
      <div flex='1'>
      <img   height='50vh' src={`${protocol}://${server_host}:3050/images/logo.png`} alt='powered by Altai ego'/>
      </div>

       <div flex='2' className='logedInName2' onClick={request_an_account_update_form}>
        {username}
      </div>

      <div flex='3'>
        <button onClick={onLogout}>Logout</button>
       </div>
       <Chrono duration={chronoDuration} server_host={server_host} setDuration={decreaseTime} 
              initial_duration={vingt_minutes} is_owner={is_owner} is_coach={is_coach} flex='4'/>
    </div>
  );
};

export default HelpChat;